import { css } from '@emotion/react';
import { alpha } from '@mui/material/styles';
import { solarWarningPalette } from './makeSolarPotentialStyles';

const makeRoofChangeQuestionStyles = ({ theme }) => {
  const { palette } = theme.mvf;
  const amber = solarWarningPalette;
  const green = palette.component.continueButtonColor;
  const softGreenBg = alpha(green, 0.1);

  return {
    banner: css({
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      backgroundColor: amber.bg,
      border: `1px solid ${amber.border}`,
      borderRadius: 8,
      padding: '12px 16px',
      margin: '16px 0',
      '@media (max-width: 540px)': {
        flexWrap: 'wrap',
      },
    }),
    warningIcon: css({
      flexShrink: 0,
      color: amber.text,
    }),
    message: css({
      flex: 1,
      fontSize: '0.8125rem',
      color: amber.text,
      lineHeight: 1.4,
      textAlign: 'left',
      '& strong': { fontWeight: 600 },
    }),
    buttons: css({
      display: 'flex',
      gap: 8,
      '@media (max-width: 540px)': {
        width: '100%',
        justifyContent: 'flex-end',
        marginTop: 8,
      },
    }),
    yesButton: css({
      padding: '8px 16px',
      borderRadius: 6,
      border: 'none',
      fontSize: '0.8125rem',
      fontWeight: 600,
      cursor: 'pointer',
      backgroundColor: amber.border,
      color: amber.text,
      '&:hover': { backgroundColor: amber.borderHover },
    }),
    noButton: css({
      padding: '8px 16px',
      borderRadius: 6,
      border: 'none',
      fontSize: '0.8125rem',
      fontWeight: 600,
      cursor: 'pointer',
      backgroundColor: palette.component.continueButtonColor,
      color: palette.text.continueButtonTextColor,
      '&:hover': {
        backgroundColor: palette.component.continueButtonHoverColor,
      },
    }),
    // Summary shown once the question is answered: soft-green row matching the
    // savings banner and potential card on this step, with an edit affordance.
    summary: css({
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: 12,
      backgroundColor: softGreenBg,
      borderRadius: 8,
      padding: '12px 16px',
      margin: '16px 0',
    }),
    summaryText: css({
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'left',
    }),
    summaryLabel: css({
      fontSize: '0.6875rem',
      color: palette.text.secondaryTextColor,
    }),
    summaryValue: css({
      fontSize: '0.875rem',
      fontWeight: 600,
      color: palette.text.primaryTextColor,
    }),
    editButton: css({
      flexShrink: 0,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: 'none',
      background: 'none',
      // Padding (and the matching negative margin) widens the tap target beyond
      // the glyph without shifting the summary layout.
      padding: 8,
      margin: -8,
      cursor: 'pointer',
      color: green,
      '& svg': { fontSize: '1.5rem' },
      '&:hover': { color: palette.component.continueButtonHoverColor },
    }),
    followUp: css({
      backgroundColor: amber.bg,
      border: `1px solid ${amber.border}`,
      borderRadius: 8,
      padding: 16,
      margin: '16px 0',
    }),
    followUpQuestion: css({
      fontSize: '0.875rem',
      fontWeight: 600,
      color: amber.text,
      marginBottom: 12,
    }),
    options: css({
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
    }),
    option: css({
      width: '100%',
      padding: '14px 16px',
      textAlign: 'left',
      borderRadius: 8,
      border: `2px solid ${palette.component.backButtonColor}`,
      backgroundColor: palette.background.widgetBackgroundColor,
      color: palette.text.primaryTextColor,
      fontSize: '0.875rem',
      fontWeight: 600,
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      '&:hover': { borderColor: green },
    }),
    optionSelected: css({
      borderColor: green,
      backgroundColor: softGreenBg,
      color: green,
    }),
  };
};

export default makeRoofChangeQuestionStyles;
